export default function Spike() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width="28"
			height="28"
			fill="currentColor"
			aria-hidden="true"
		>
			<path fill="none" d="M0 0h24v24H0z" />
			<path d="M13 10H20L11 23V14H4L13 1V10Z" />
		</svg>
	);
}
